/**
 * Document-related constants used across the application.
 */

export { SUPPORTED_FILE_TYPES_STRING } from './supported-file-types';

/** Special folder name for correspondence/email documents */
export const CORRESPONDENCE_FOLDER_NAME = 'Correspondence';

/** Canonical path for the root system Correspondence folder */
export const CORRESPONDENCE_FOLDER_PATH = '/correspondence/';

/** Canonical path for the system Attachments folder under Correspondence */
export const CORRESPONDENCE_ATTACHMENTS_FOLDER_PATH = '/correspondence/attachments/';

/** Maximum characters to display for document names before truncating */
export const DOCUMENT_NAME_MAX_LENGTH = 30;
